import { HttpError } from '../http/HttpClient';

export class ApiClient {
  constructor({ http, tokenStore, auth, basePath = '/api' }) {
    this.http = http;
    this.tokenStore = tokenStore;
    this.auth = auth;
    this.basePath = basePath;
  }

  async safeCall(fn) {
    try { return await fn(); }
    catch (e) {
      if (e instanceof HttpError && e.status === 401 && this.auth) {
        console.log('refresh token');
        await this.auth.refresh();
        return await fn();
      }
      throw e;
    }
  }
  
  _resolveUrl(resource) {
    return resource.startsWith('/') 
      ? `${this.basePath}${resource}` 
      : `${this.basePath}/${resource}`;
  }

  list(resource, query) {
    const qs = query ? `?${new URLSearchParams(Object.entries(query).map(([k, v]) => [k, String(v)]))}` : '';
    // Usamos el helper y le pegamos el QueryString al final
    return this.safeCall(() => this.http.get(`${this._resolveUrl(resource)}${qs}`));
  }

  get(resource) {
    return this.safeCall(() => this.http.get(this._resolveUrl(resource)));
  }

  create(resource, payload) {
    return this.safeCall(() => this.http.post(this._resolveUrl(resource), payload));
  }

  update(resource, payload) {
    return this.safeCall(() => this.http.put(this._resolveUrl(resource), payload));
  }

  remove(resource) {
    return this.safeCall(() => this.http.delete(this._resolveUrl(resource)));
  }

  request({ method, resource, body, opts = {} } = {}) {
    return this.safeCall(() => this.http.request(method, this._resolveUrl(resource), body, opts));
  }
}